import { Icons } from "assets/icons";
import { InputSwitch } from "primereact/inputswitch";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const Switch = ({
  checked = false,
  handleOnChange = () => {},
  disabled = false,
  label = null,
  infoText = null,
  minWidth = 48
}) => {
  const { info } = Icons || {};
  return (
    <div style={{ minWidth }}>
      {label && (
        <label className="w-100 d-flex align-items-center gap-1">
          {label}

          {infoText && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>{infoText}</Tooltip>}
            >
              <img
                src={info}
                alt="info"
                width={15}
                height={15}
                style={{ cursor: "pointer" }}
              />
            </OverlayTrigger>
          )}
        </label>
      )}

      <InputSwitch
        className="custom_switch"
        checked={checked}
        onChange={handleOnChange}
        disabled={disabled}
      />
    </div>
  );
};

export default Switch;
